export function getGtmEventClickData(element, debug = false) {
  if (!element) {
    return true;
  }

  const eventData = {
    "gtm.hitType": element.getAttribute("data-track-hit-type") || "",
    "gtm.elementCategory":
      element.getAttribute("data-track-event-category") || "",
    "gtm.elementAction": element.getAttribute("data-track-event-action") || "",
    "gtm.elementLabel": element.getAttribute("data-track-event-label") || "",
    "gtm.elementValue": element.getAttribute("data-track-event-value") || "",
    redirect: element.getAttribute("data-track-redirect") || false,
  };

  return setGtmData(eventData, debug);
}

export function setGtmData(eventData, debug = false) {
  // console.log("eventData", eventData);

  try {
    let dataLayerEvents = window.localStorage.getItem("dataLayerEvents");

    if (
      dataLayerEvents !== undefined &&
      dataLayerEvents !== null &&
      dataLayerEvents.length > 0
    ) {
      // Add events from local storage.
      dataLayerEvents = JSON.parse(dataLayerEvents);
    } else {
      dataLayerEvents = [];
    }

    let redirect = eventData.redirect;
    delete eventData.redirect;

    dataLayerEvents.push(eventData);
    // console.log('pushing', dataLayerEvents);
    // Store events to local storage so can be loaded on page load.
    window.localStorage.setItem(
      "dataLayerEvents",
      JSON.stringify(dataLayerEvents)
    );
    // console.log('redirect', typeof redirect, redirect);
    if (redirect === false || redirect === "false") {
      // console.log('redirect is false');
      updateTagEvents();
    } else {
      setTimeout(function () {
        // console.log('timeout');
        window.location.href = eventData["gtm.elementLabel"];
      }, 200);
    }

    return false;
  } catch (error) {
    console.error(error);
    return true;
  }
}

export function updateTagEvents() {
  // console.log("updating tag events");
  try {
    let dataLayerEvents = window.localStorage.getItem("dataLayerEvents");
    // console.log("dle", dataLayerEvents);
    window.dataLayer = window.dataLayer || [];
    if (dataLayerEvents !== undefined && dataLayerEvents !== null) {
      // Add events to data layer from local storage.
      window.dataLayer = window.dataLayer.concat(JSON.parse(dataLayerEvents));
      // console.log(window.dataLayer);
      // Clear out old saved data later events.
      window.localStorage.removeItem("dataLayerEvents");
      // console.log('wdl', window.dataLayer);
    }
  } catch (error) {}
}
